import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, finalize, map, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { TipologieCantieriActions } from './tipologie-cantieri.actions';
import { TipoCantierePort } from '../../core/services/tipoCantiere/tipo-cantiere.port';
import { LoadingService } from '../../core/services/loading/loading.service';
import { selectLoaded } from './tipologie-cantieri.selectors';

@Injectable()
export class TipologieCantieriEffects {
  private actions$ = inject(Actions);
  private api = inject(TipoCantierePort);
  private store = inject(Store);
  private loading = inject(LoadingService);

  loadList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TipologieCantieriActions.loadList),
      withLatestFrom(this.store.select(selectLoaded)),
      filter(([, loaded]) => !loaded),
      switchMap(() =>
        this.api.getList({ size: 200, offset: 0 }).pipe(
          map(res => TipologieCantieriActions.loadListSuccess({ items: res.content })),
          catchError(err =>
            of(TipologieCantieriActions.loadListFailure({ error: err?.message ?? 'Errore caricamento tipologie cantiere' }))
          ),
        )
      )
    )
  );

  create$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TipologieCantieriActions.create),
      tap(() => this.loading.show()),
      switchMap(({ dto }) =>
        this.api.create(dto).pipe(
          map(id => TipologieCantieriActions.createSuccess({ item: { id: Number(id), tipo: dto.tipo } })),
          catchError(err =>
            of(TipologieCantieriActions.createFailure({ error: err?.message ?? 'Errore creazione tipologia cantiere' }))
          ),
          finalize(() => this.loading.hide()),
        )
      )
    )
  );
}
